<template>
  <el-form label-position="left" :model="formData" ref="ruleForm" :rules="rules" @validate="handleValidate"  label-width="120px">
    <formGroup>账户&产品</formGroup>
    <el-form-item label="目标账户" prop="account">
      <ESelect   
        class="input-width" 
        filterable
        remote
        v-model="formData.account" 
        :remote-method="handleRemoteMethod"
        :loading="accountLoading"
        placeholder="请选择要创建广告的目标账户"
        ref="accountRef"
        @visible-change="visibleVirtualoptions"
        @change="(data)=>handleAccountChange(data)"
      >
        <VirtualList
          ref="virtualList"
          data-key="account_id"
          style="max-height: 245px; overflow-y: auto;"
          :data-sources="accountDataList"
          :data-component="itemComponent"
          :keeps="20"
          :estimate-size="50"
        />
      </ESelect>
    </el-form-item>
   <div class="tip_box">
     <el-form-item label="产品" prop="product">
        <ESelect   
          clearable 
          class="input-width" 
          ref="productRef"
          filterable
          remote
          multiple
          reserve-keyword
          v-model="formData.product" 
          :remote-method="handleRemoteAppMethod"
          :loading="appLoading"
          :disabled="!formData.account"
          :placeholder="!formData.account?'请先选择目标账户':'请选择要投放的产品，可多选'"
          @change="handleProductChange"
        >
          <el-option 
            v-if="!appList.length"
            value="item.app_id" disabled>
              <p class="tac pt6">暂无数据</p>
            </el-option>
          <el-option 
            v-for="item in appList" 
            :key="item.app_id"
            :label="`${item.app_name}(${item.app_id})`" 
            :value="item.app_id"
          >
            {{item.app_name}}({{item.app_id}}) ({{item.package_name}})
          </el-option>
        </ESelect>
        <el-button   
          style="margin-left:15px" 
          type="primary" 
          plain
          @click="handleBatchClick"
        >
          批量录入
        </el-button>
        <div class="el-form-item__error form-item_tip">可选产品来源于【客户产品管理】模块，已经绑定至目标账户对应客户且是启用状态的产品</div>
      </el-form-item>
    </div>
    <formGroup>计划</formGroup>
    <formGroup :level="2">基础信息</formGroup>
    <el-form-item label="投放范围" prop="range">
      <el-checkbox-group size="mini" v-model="formData.range">
        <el-checkbox-button 
          v-for="item in rangeList" 
           @change="(data)=>handleRangeChange(data, item)"
          :label="item.value" :key="item.value">
          {{item.label}}
        </el-checkbox-button>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="计划预算" prop="budget">
      <el-input class="input-width" placeholder="不可少于200，大于等于1亿元" v-model.number="formData.budget"/>
    </el-form-item>
    <el-form-item label="投放方式" prop="mode">
      <el-radio-group size="mini" v-model="formData.mode">
        <el-radio-button 
          v-for="item in modeList" 
          :label="item.value" :key="item.value">
          {{item.label}}
        </el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="投放日期" required>
      <el-radio-group v-model="timeType" @change="handleTimeTypeChange">
        <el-radio :label="TIME_TYPE.CUSTOM">自定义开始日期</el-radio>
        <el-radio :label="TIME_TYPE.DYNAMIC">动态当天</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item  prop="startTime">
      <template v-if="!!formData.startTime">
        <el-date-picker
          v-model="formData.startTime"
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="pickerStartOptions"
          :clearable="false"
          :editable="false"
          placeholder="选择投放开始日期">
        </el-date-picker>
      </template>
      <template v-else><span style="color: #333;font-size:12px">动态当天开始日期</span></template>
      -
      <el-date-picker
        v-model="formData.endTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerEndOptions"
        clearable
        :editable="false"
        placeholder="选择投放结束日期">
      </el-date-picker>
      <div 
        v-if="timeType ===TIME_TYPE.DYNAMIC&&formData.endTime" 
        class="el-form-item__error form-item_tip"
      >
        建议不选择结束日期，否则可能会造成开始日期大于结束日期，导致创建失败
      </div>
    </el-form-item>
    <el-form-item label="流量优选"  required>
      <el-switch
        v-model="formData.optimal"
      >
      </el-switch>
    </el-form-item>
    <el-form-item label="自动优化"  required>
      <span style="color: #333;font-size:12px">关闭</span>
      <!-- <el-switch
        v-model="formData.optimize"
      >
      </el-switch> -->
    </el-form-item>
    <el-form-item label="计划名称" prop="name"  >
      <inputSelect 
        placeholder="您可输入或选择通配符动态生成名称，但最终结果名称不可超过60字" 
        v-model="formData.name"
        @change="(value)=>$emit('update:planName', value)"
        @tab-click="data=>data.cb&&data.cb()"
        input-style="width:600px"
        :list="nameList"
      />
    </el-form-item>
     <el-form-item label="状态" required>
      <el-switch v-model="formData.state"/>
    </el-form-item>
  </el-form>
</template>

<script>
import formGroup from './formGroup.vue'
import inputSelect from './inputSelect.vue'
import { validEmoji } from '@/utils/validate'
import { parseTime } from '@/utils'
import VirtualList from 'vue-virtual-scroll-list'
import OptionsItem from '@/components/BatchMultipleSelect/item.vue'
import { batchEnterModal } from '../modal';
const TIME_TYPE = Object.freeze({
  CUSTOM: 1,
  DYNAMIC: 2
})
export default {
  components: { formGroup, inputSelect, VirtualList },
  inject: ['getOption', 'validFormItem', 'nameCb'],
  props: {
    dataId:String,
    campaignType: Array,
    accountList: Array,
    appList: Array,
    accountLoading: Boolean,
    appLoading: Boolean,
    displayType: Array,
    defaData: Object,
    addType: Number,
    apps: Array
  },
  data() {
    const validateBudget = (rule, value, callback)=> {
      if (value<200 || value >=100000000) {
        callback(new Error('不可小于200，大于等于1亿'))
      }else {
        callback()
      }
    }
    const validateName = (rule, value, callback)=> {
      if (validEmoji(value)) {
        callback(new Error('不可包含表情'))
      }else {
        callback()
      }
    }
    const validateTime =(rule, value, callback)=> {
      if (!value) {
         callback()
      }else {
        if (new Date(value).getTime()<new Date(parseTime(new Date(), '{y}-{m}-{d}')).getTime()) {
          callback(new Error('所选日期不能是今天以前的时间'))
        }else {
          callback()
        }
      }
    }
    return {
      timeType: TIME_TYPE.DYNAMIC,//日期类型
      TIME_TYPE,
      updateAccount: false,
      itemComponent: OptionsItem,
      preAccount: '', //选中的账户
      preProductList: [],//选中的产品
      rangeList:[],
      modeList: [],
      nameList: [],
      formData: {
        account: '',//账户
        product: [],//产品
        range: [],//投放范围
        budget: 200,//计划预算
        mode: '',//投放方式
        startTime: '',//投放日期
        endTime: '',//投放日期
        optimal: false,//流量优选
        optimize: false,//流量优化
        name: '{项目名称}-{版位}-{跟踪类型}-{转化类型}-{素材规格}-{创建日期}-{任务号-顺序号}-wk', //计划名称
        state: false,//状态
      },
      rules: {
        // blur
        account: [
          { required: true, message: '目标账户不可为空，请选择目标账户', trigger: 'change' }
        ], 
        product: [
          { required: true, message: '产品不可为空，请选择产品', trigger: 'change' }
        ],
        range: [
          { required: true, message: '最少需要选择一个投放范围', trigger: 'change' }
        ],
        budget: [
          { required: true, message: '请输入预算', trigger: 'blur' },
          { type: 'number', message:'请输入数字', trigger: 'blur' },
          { validator: validateBudget, trigger: 'blur' },
        ],
        mode: [
          { required: true, message: '请选择投放方式', trigger: 'change' }
        ], 
        startTime: [
          { required: true,validator: validateTime, trigger: 'change' }
        ], 
        name: [
          { required: true, message: '请输入或者选择生成计划名称', trigger: 'change' },
          { validator: validateName, message:'不可输入表情', trigger: 'blur' },
        ], 
      },
      pickerStartOptions: {
        disabledDate: (time)=> {
          const end = this.formData.endTime
          const start = time.getTime() < (Date.now()-24*60*60*1000)
          if (end) {
            return new Date(end).getTime()<time.getTime() || start;
          }else {
            return start
          }
        }
      },
      pickerEndOptions: {
         disabledDate:(time)=>{
          if (this.formData.startTime) {
            return time.getTime() < new Date(this.formData.startTime).getTime()-24*60*60*1000;
          }else {
            return time.getTime() < (Date.now()-24*60*60*1000)
          }
        }
      },
      accountDataList: [],
    }
  },
  computed: {
   
  },
  created() {
    const { campaign_type, delivery_policy, wildcard_plan_name } =  this.getOption();

    this.rangeList = campaign_type.map(v=> {
      if (v.required) {
        this.formData.range.push(v.param_id);
      }
      return {
        label: v.param_name,
        value: v.param_id,
        ...v
      }
    });
    this.$emit('update:campaignType', [...campaign_type])
    this.modeList = delivery_policy.map((v, i)=> {
      if (v.required) {
        this.formData.mode = v.param_id;
      }
      return {
        label: v.param_name,
        value: v.param_id,
        ...v
      }
    });
    this.nameList = wildcard_plan_name.map(v=> {
      this.nameCb(v);
      return {
        label: v.param_name,
        value: v.param_name,
        ...v
      }
    });
    this.$emit('update:planName', this.formData.name)
  },
  watch:{
    accountList() {
       this.visibleVirtualoptions(true)
    }
  },
  mounted() {},
  methods: {
    handleTimeTypeChange(val) {
      if (TIME_TYPE.CUSTOM === val) {
        this.formData.startTime = parseTime(new Date(), '{y}-{m}-{d}')
      }else {
        this.formData.startTime = ''
      }
      this.formData.endTime = ''
    },
    // 批量录入
    handleBatchClick() {
      if (!this.formData.account) {
        this.$message.error('请先选择目标账户')
        return;
      };
      const onSubmit = (data)=> {
       const appIdObj =  this.appList.reduce((pre, item)=>{
          pre[item.app_id] = true
          return pre;
        },{});
        const list = []
        data.forEach(v=>{
          if (!appIdObj[v.app_id]) {
            list.push(v)
          }
        });
        this.appList.push(...list);
        const appList = [...new Set([...this.formData.product, ...data.map(v=>v.app_id)])]
        // 去重， 防止id重复
        this.formData.product = appList
        this.updateProductType()
        vm.close()
      }
      const { vm } = batchEnterModal({
        props: {
          id: this.formData.account
        },
        cbs: {
          onSubmit
        }
      })
    },
    // 更新产品
    handleProductChange(data) {
      if (this.preProductList.length >data.length) {
        this.formData.product = this.preProductList;
        this.$bus.$emit('hasAddDate',this.displayType,(b)=> {
          if (b) {
             const tip = this.addType === 1
            ?'删除后已经录入的该产品信息（创意组）将同步删除，确认要删除吗？'
            :'删除后已经录入的该产品信息（转化出价、创意组）将同步删除，确认要删除吗？';
             this.$confirm(tip, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.preProductList = data;
              this.formData.product = data;
              this.$refs.productRef.blur();
              this.updateProductType()
            }).catch(() => {
              this.formData.product = this.preProductList
            });
          }else {
            this.preProductList = data;
            this.formData.product = data;
            this.updateProductType()
          }
        })
       
      }else {
        this.preProductList = data;
        this.updateProductType()
      }
    },
    // 更新账户
    handleAccountChange(data) {
      if (this.preAccount) {
        this.formData.account = this.preAccount;
        // this.$confirm('修改目标账户将重置产品、定向人群、排除人群、转化出价、创意组的内容，确定要修改吗？', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   this.preAccount = data;
        //   this.formData.account = data;
        //   this.$refs.accountRef.blur();
        //   this.formData.product=[];
        //   this.updateProductType()
        //   this.handleRemoteAppMethod('')
        //   this.$emit("update:account", data)
        // }).catch(() => {
        //   this.formData.account = this.preAccount
        // });
        const { product } = this.formData
           if (product&&product.length) {
            const tip = this.addType === 1
            ?'修改目标账户将重置产品、定向人群、排除人群、创意组的内容，确定要修改吗？'
            :'修改目标账户将重置产品、定向人群、排除人群、转化出价、创意组的内容，确定要修改吗？';
            this.$confirm(tip, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.preAccount = data;
              this.formData.account = data;
              this.$refs.accountRef.blur();
              this.formData.product=[];
              this.updateProductType()
              this.handleRemoteAppMethod('')
              this.$emit("update:account", data)
            }).catch(() => {
              this.formData.account = this.preAccount
            });
          }else {
            this.preAccount = data;
            this.formData.account = data;
            this.formData.product=[];
            this.updateProductType()
            this.handleRemoteAppMethod('')
            this.$emit("update:account", data)
          }
        
      }else {
        this.preAccount = data;
        this.$emit("update:account", data)
        this.handleRemoteAppMethod('')
      }
    },
    // 产品更新
    handleRemoteAppMethod(search) {
      const params = {
        account_id: this.formData.account,
        search
      }
      this.$emit('updateApp', params)
    },
    // 账户远程搜索
    handleRemoteMethod(v) {
      this.$emit('updateAccount', v)
    },
    visibleVirtualoptions(bool) {
      if (bool) {
        if (this.updateAccount) {
          this.handleRemoteMethod('')
          this.updateAccount = false
        }
        this.accountDataList = this.accountList.map(v=> {
          return {
            ...v,
            value: v.account_id,
            label: `${v.account_name}(${v.account_id})`
          }
        })
      }else {
        this.accountDataList = []
        this.$refs.virtualList.reset()
      }
    },
    handleValidate(key, valid, info) {
      const data = {
        account: '账户&产品-目标账户',
        product: '账户&产品-产品',
        range: '计划-投放范围',
        budget: '计划-计划预算',
        mode: '计划-投放方式',
        startTime: '计划-投放日期',
        name: '计划-计划名称',
      };
      if (!valid) {
        this.validFormItem(`${data[key]}：${info}`)
      }
    },
    // 获取表单数据
    async validateFn() {
        const valid = await this.$refs.ruleForm.validate();
        
        if (valid) {
          return {...this.formData}
        }
       
    },
    setFormData(data) {
      this.$emit('update:planName', data.name)
      this.formData = {
        ...data,
      };
      // 除了预览上一步都没数据
      if (Object.keys(this.defaData).length===0) {
        this.timeType = TIME_TYPE.DYNAMIC
        this.formData.startTime = '';
        this.formData.endTime = ''//投放日期
      }else {
        if (data.startTime) {
          this.timeType = TIME_TYPE.CUSTOM
        }
      }
      this.handleRemoteAppMethod("")
      this.handleRemoteMethod(data.account)
      this.updateCampaignType()
       this.$emit("update:account", data.account)
       this.preAccount = data.account
       this.preProductList =[...data.product]
       this.updateAccount = true
      const unwatch = this.$watch(
        'appList',
        ()=> {
          this.updateProductType()
          if (unwatch) {
            unwatch()
          }
        },
        { immediate: true }
      )
    },
    handleRangeChange(data,item) {
      if (!data) {
        const { display_type } = this.getOption();
        // 固定应用下载为2  后期可能会迭代
        const list = display_type.filter(v=>[ `${item.value}_2`].includes(v.pid))
        this.$bus.$emit('hasAddDate',list,(b)=> {
          if (b) {
            this.$confirm('取消该投放范围后已经录入的相关信息（版位、转化出价、创意组）将同步删除，确认要取消吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.updateCampaignType()
            }).catch(() => {
              this.formData.range.push(item.value)
            }); 
          }else {
            this.updateCampaignType()
          }
        })
      }else {
        this.updateCampaignType()
      }
    },
    // 更新产品
    updateProductType() {
      console.log(this.formData.product, 'aaa');
      const data = this.apps.filter(v=>[...this.formData.product].includes(v.app_id));
      const ids = data.map(v=>v.app_id)
      const arr = [...this.formData.product].filter(v=>!ids.includes(v)) 
      this.$emit('update:apps', [...data, ...this.appList.filter(v=>arr.includes(v.app_id))])
    },
    // 更新投放范围
    updateCampaignType() {
       this.$emit('update:campaignType', [...this.rangeList.filter(v=>this.formData.range.includes(v.value))])
    }
  }
}
</script>
<style lang="scss" scoped>

.input-width {
  width: 600px;
}
.form-item_tip {
  color: #7F7F7F;
}
.tip_box::v-deep .el-form-item__error{
  width: 100%;
  background-color: #fff;
}
</style>
